import React from 'react'
import { ReactSVG } from 'react-svg'
import Kdabra from '../assets/logo/kdabra.svg'
import CompactLight from '../assets/logo/kdabra-compact-light.svg'
import styled from 'styled-components'

const WrapperIcon = styled.div`
  width: fit-content;
  height: fit-content;
  border-radius: 50%;
  box-shadow: rgb(192 203 255 / 42%) 0px 0px 2px 1px;
`

const KdabraIconSVG = ({ src }) => (
  <WrapperIcon>
    <ReactSVG src={src} />
  </WrapperIcon>
)

const KdabraIcon = () => <KdabraIconSVG src={Kdabra} />

KdabraIcon.CompactLight = () => <KdabraIconSVG src={CompactLight} />

export default KdabraIcon
